document.addEventListener("DOMContentLoaded", function() {
    const shopDomain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.hostname;
    const blockedDomainPattern = /^shopsta\.(fr|es|it|pt|gr|mt|cy)$/i;

    if (blockedDomainPattern.test(shopDomain)) {
        return;
    }
    // --- Remove Loox review brackets ---
    function removeLooxBrackets() {
      const reviewContainer = document.querySelector('.satcb_reviews_stars');
      // Check if the element exists and hasn't been processed yet
      if (reviewContainer && !reviewContainer.dataset.looxFormatted) {
        const looxWidget = reviewContainer.querySelector('.loox-rating.loox-widget');
        const ratingLabel = reviewContainer.querySelector('.loox-rating-label');
        
        // Ensure both the widget with data and the label to update exist
        if (looxWidget && ratingLabel) {
          // Get the rating directly from the data-rating attribute for reliability
          const rating = looxWidget.getAttribute('data-rating');
  
          if (rating) {
            // Hide, modify, then show to prevent visual glitching/shifting
            reviewContainer.style.visibility = 'hidden';
            
            // Set the label's content to be just the rating value.
            // The original HTML had a non-breaking space, so we'll add it back.
            ratingLabel.innerHTML = `&nbsp;${rating}`;
            
            reviewContainer.style.visibility = 'visible';
  
            // Mark as processed to prevent this from running again
            reviewContainer.dataset.looxFormatted = 'true';
          }
        }
      }
    }
  
    // --- Currency setup ---
    const removableSuffixes   = ['AUD','CAD','NZD','EUR','GBP','USD'];
    const suffixToPrefixMap   = { AUD:'A$', CAD:'CA$', NZD:'NZ$', USD:'$', EUR:'€', GBP:'£' };
    const containersSelector = [
      '.price__current', '.satcb_price', '.satcb_was_price', '.cart-item--sale-price',
      '.atc-subtotal--price', '.atc--product-details--price-value',
      '.cart-item--content-price', '.cart-item__total',
      '.cart-subtotal', '.atc-banner--cart-subtotal',
      '.cart-title-total--small'
    ].join(',');
    const currencySuffixRegex = /[\d,]+[.]\d{2}\s[A-Z]{3}$/;
    const currencyMatchRegex  = /^(CA\$|NZ\$|A\$|\$|€|£)?\s?([\d,]+)\.(\d{2})$/;
  
    function formatPrices() {
      document.querySelectorAll(containersSelector).forEach(container => {
        let els = container.querySelectorAll('.money');
        if (!els.length && container.classList.contains('money')) els = [container];
  
        els.forEach(el => {
          // already done?
          if (el.dataset.formatted === "true" || el.querySelector('.price-symbol')) return;
  
          // 1) merge any standalone "CA" / "NZ" / "A" span immediately before us
          let prefixText = '';
          const prev = el.previousElementSibling;
          if (
            prev &&
            prev.classList.contains('money') &&
            !prev.querySelector('.price-symbol')
          ) {
            const t = prev.textContent.trim();
            if (['CA','NZ','A'].includes(t)) {
              prefixText = t;
              prev.remove();
            }
          }
  
          // 2) get raw text & strip ISO suffix (e.g. "179,95 EUR")
          let raw = el.textContent.trim();
          let cleaned = raw;
          let overrideCur = null;
          const sufMatch = cleaned.match(/([\d.,]+)\s*([A-Z]{3})$/);
          if (sufMatch && removableSuffixes.includes(sufMatch[2])) {
            cleaned = cleaned.replace(/\s*[A-Z]{3}$/,'');
            overrideCur = suffixToPrefixMap[sufMatch[2]];
          }
  
          // 3) grab leading symbol (€, $, A$, etc.)
          const symMatch = cleaned.match(/^(CA\$|NZ\$|A\$|\$|€|£)/);
          let symbol = overrideCur || (symMatch ? symMatch[1] : '$');
          let numPart = cleaned.replace(/^(CA\$|NZ\$|A\$|\$|€|£)/,'').trim();
  
          // 4) normalize EU vs US format
          const commaAsDec = numPart.lastIndexOf(',') === numPart.length - 3;
          if (commaAsDec) {
            numPart = numPart.replace(/\./g,'').replace(',','.');
          } else {
            numPart = numPart.replace(/,/g,'');
          }
  
          // 5) split into whole + fraction
          const m = numPart.match(/^(\d+)\.(\d{2})$/);
          if (!m) return;
          const [ , whole, frac ] = m;
  
          // 6) prepend any prefixText (CA/NZ/A)
          const fullSymbol = prefixText + symbol;
  
          // 7) render
          const html =
            `<span class="price-symbol">${fullSymbol}</span>` +
            `<span class="price-whole">${whole}</span>` +
            `<span class="price-fraction">${frac}</span>`;
  
          if (el.closest('.satcb_price, .satcb_was_price')) {
            el.innerHTML = `<div class="satcb_price_inner">${html}</div>`;
            el.style.visibility = 'visible';
          } else {
            el.innerHTML = html;
          }
          el.dataset.formatted = "true";
        });
      });
    }
  
    // --- Function to run all dynamic updates ---
    function handleDOMChanges() {
      removeLooxBrackets();
      formatPrices();
    }
  
    // --- initial + dynamic ---
    handleDOMChanges(); // Run once for initial page load
    new MutationObserver(handleDOMChanges) // Run on any subsequent DOM changes
      .observe(document.body, { childList: true, subtree: true });
  });
  
  